export class PodMetricsSummaryTask {
  id = 0;

  name = '';

  notStarted = 0;

  attempted = 0;

  completed = 0;

  total = 0;

  employees: PodMetricsSummaryTask[];

  constructor(obj: any) {
    Object.assign(this, obj);
    this.employees = obj.employees || [];
  }

  static sort(
    { total: a }: PodMetricsSummaryTask,
    { total: b }: PodMetricsSummaryTask,
  ) {
    return b - a;
  }
}

export default PodMetricsSummaryTask;
